import { useSyncExternalStore } from "react";
import { getServerClockOffset, subscribeServerClock } from "@/utils/serverClock";
import { getCurrentDateYMDformat } from "@/utils/helper";

/**
 * Today's `YYYY-MM-DD` by the server clock. Re-renders when the first API
 * response corrects the offset, so a query keyed on it refetches the right day
 * even when the laptop's date is wrong.
 */
export const useServerToday = (): string => {
  useSyncExternalStore(subscribeServerClock, getServerClockOffset);
  return getCurrentDateYMDformat();
};
